// Google Ads / Analytics conversion helper
export const trackContactConversion = () => {
  if (typeof window !== "undefined" && typeof (window as any).gtag === "function") {
    (window as any).gtag("event", "conversion_event_contact", {});
  }
};
